class FilterConfig extends BaseItemConfig {

    applyCondition: KnockoutObservable<FilterWidgetApplyConditionEnum>;
    boundField: KnockoutObservable<number>;
    boundFieldVisible: KnockoutObservable<boolean>;
    condition: KnockoutObservable<FilterWidgetConditionEnum>;
    conditionType: KnockoutObservable<FilterConditionTypeEnum>;
    displayField: KnockoutObservable<number>;
    dynamicParameter: KnockoutObservable<boolean>;
    dynamicParameterName: KnockoutObservable<string>;
    editorType: KnockoutObservable<FilterWidgetEditorTypeEnum>;
    filterId: KnockoutObservable<string>;
    mappingFilter: KnockoutObservable<number>;
    mappingFilterName: KnockoutObservable<string>;
    metricField: KnockoutObservable<number>;
    scopeAction: KnockoutObservable<ScopeActionEnum>;
    titleText: KnockoutObservable<string>;
    titleTextConfig: BaseTextConfig;
    values: FilterWidgetValue;
    //    { listValues: Array(0), dates: {… } }
    valuesTextConfig: BaseTextConfig;
    allValuesSelected: KnockoutObservable<boolean>;
    showNullButton: KnockoutObservable<boolean>;

    get filterName() {
        return MappingService.getFilterName(this.mappingFilter()) || MappingService.getFieldName(this.boundField());
    }
    get filterEditorType() {
        switch (this.editorType()) {
            case FilterWidgetEditorTypeEnum.DropDown:
            case FilterWidgetEditorTypeEnum.List:
                if (this.conditionType() == FilterConditionTypeEnum.Equals || this.conditionType() == FilterConditionTypeEnum.Different)
                    return FilterEditorTypeEnum.ValuesCombo;

                return FilterEditorTypeEnum.MultiSelect;
            case FilterWidgetEditorTypeEnum.DateRange:
                return  FilterEditorTypeEnum.DateRange;
            case FilterWidgetEditorTypeEnum.Date:
                return FilterEditorTypeEnum.Date;
            default:
                throw new Error(`Not Implemented: ${this.editorType() }`);
        }
    }

    constructor(data: any) {
        super(data);
        
        this.applyCondition = ko.observable(data.applyCondition);
        this.boundField = ko.observable(data.boundField);
        this.boundFieldVisible = ko.observable(data.boundFieldVisible);
        this.condition = ko.observable(data.condition);
        this.conditionType = ko.observable(data.conditionType);
        this.displayField = ko.observable(data.displayField);
        this.dynamicParameter = ko.observable(data.dynamicParameter);
        this.dynamicParameterName = ko.observable(data.dynamicParameterName);
        this.editorType = ko.observable(data.editorType);
        this.filterId = ko.observable(data.filterId);
        this.mappingFilter = ko.observable(data.mappingFilter);
        this.mappingFilterName = ko.observable(data.mappingFilterName);
        this.metricField = ko.observable(data.metricField);
        this.scopeAction = ko.observable(data.scopeAction);
        this.titleText = ko.observable(data.titleText);
        this.titleTextConfig = new BaseTextConfig(data.titleTextConfig);
        this.values = new FilterWidgetValue(data.values);
        this.valuesTextConfig = new BaseTextConfig(data.valuesTextConfig);
        this.allValuesSelected = ko.observable(data.allValuesSelected);
        this.showNullButton = ko.observable(data.showNullButton);
    }
    get allowDetailTab(): boolean {
        return false;
    }
}

enum FilterWidgetConditionEnum {
    MultipleSelection,
    SingleSelection,
    Between
}
enum FilterWidgetEditorTypeEnum {
    DropDown,
    List,
    DateRange,
    Date
}
enum FilterWidgetApplyConditionEnum {
    Manually,
    Automatic
}

class FilterWidgetValue {
    listValues: KnockoutObservableArray<any>;
    dates: FilterWidgetDateRange;

    constructor(data) {
        this.listValues = ko.observableArray(data.listValues);
        this.dates = new FilterWidgetDateRange(data);
    }
}

class FilterWidgetDateRange {
    dateRangeConfig: DateRangeConfigFilter;
    typeDateRange: KnockoutObservable<number>;
    startDate: KnockoutObservable<string>;
    endDate: KnockoutObservable<string>;

    constructor(data) {
        this.dateRangeConfig = new DateRangeConfigFilter(data.dateRangeConfig);
        this.typeDateRange = ko.observable(data.typeDateRange);
        this.startDate = ko.observable(data.startDate);
        this.endDate = ko.observable(data.endDate);
    }
}